export default __webpack_public_path__ + "static/media/belfor-logo-black.43f26d2b.jpg";